<style scoped>
.content {
  /* height: 100%; */
}

.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}

.rate-box {
  height: 77px;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.rate-top {
  display: flex;
  justify-content: space-between;
}

.title-box {
  font-size: 16px;
}

.operation {
  font-size: 14px;
  color: blue;
}

.double-num {
  font-size: 20px;
  color: red;
  margin-top: 10px;
}

.text-num {
  font-size: 16px;
}

.right-content {
  flex: 1;
  overflow: hidden;
}

.el-col-5 {
  width: 33.3%;
}

.el-drawer {
  overflow-y: auto;
}

.el-drawer__body {
  padding: 0 40px;
}

.batch {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  margin-bottom: 30px;
  background: #ddecef;
  border-radius: 4px;
}

.batch img {
  margin-right: 10px;
}

.rate {
  display: flex;
}

.rate-left {
  width: 145px;
  flex-shrink: 0;
}

.rate-right {
  width: 100%;
}

.el-table--border th.gutter:last-of-type {
  display: block !important;
}

/deep/.el-drawer__header {
  margin-bottom: 25px;
}

/deep/.el-tabs__header {
  margin-bottom: 20px;
}

.add-detail-button {
  height: 40px;
  line-height: 40px;
  border-top: 0 !important;
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.el-icon-plus {
  color: #dcdcdd;
}

.to-commodity-rate {
  color: #4fa1a4;
  cursor: pointer;
}

/* 上传 */
/deep/.el-upload--text {
  display: block;
}

/deep/.el-upload-list__item:first-child {
  margin-top: 0;
}

.el-dialog-div {
  height: 80vh;
}

.checkPdf {
  cursor: pointer;
  color: #4fa1a4;
}

.ipt-sty {
  width: 70% !important;
}

.upload-demo {
  overflow: hidden;
}
</style>
<template>
  <div class="content" style="display: flex">
    <div class="left-content">
      <div class="rate-box">
        <div class="rate-top">
          <div class="title-box ft16">缺省费率</div>
          <div class="operation ft14 txt-color">
            <span class="cursor-sty" v-show="showEdit" @click="editRate()">编辑</span><span class="cursor-sty"
              v-show="!showEdit" @click="editDefaultRate()">保存</span>
          </div>
        </div>
        <div class="double-num ft20">
          <el-input v-show="rateInput" style="width: 50%" v-model="numRate" maxlength="5"
            :clearable="true"></el-input><span v-show="rateShow"
            v-if="defaultRate == '' || defaultRate == null">0</span><span v-show="rateShow" v-else>{{ defaultRate |
              numDigit }}</span>％
        </div>
        <!-- <div class="text-num ft16">百分之{{ defaultRate | numDigit }}</div> -->
      </div>
      <el-table :data="hosData" style="width: 100%" @row-click="getDetails">
        <el-table-column type="index" label="序号" width="70"></el-table-column>
        <el-table-column prop="hosName" label="医院"></el-table-column>
      </el-table>
    </div>
    <div class="right-content">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="5">
            <div class="search-area-div">供应商：</div>
            <el-input v-model="page.supplierName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input>
          </el-col>
          <!-- <el-col :span="5">
                              <div class="search-area-div">收费状态：</div>
                              <el-select v-model="page.chargeState" placeholder="请选择" class="ipt-sty" :clearable="true">
                                <el-option v-for="item in chargeStateList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option> </el-select>
                            </el-col> -->
          <el-col :span="5">
            <div class="search-area-div">签约状态：</div>
            <el-select v-model="page.signingFlag" placeholder="请选择" class="ipt-sty" :clearable="true">
              <el-option v-for="item in signingStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option> </el-select>
          </el-col>
          <el-col :span="5">
            <div class="search-area-div">费率类型：</div>
            <el-select v-model="page.rateType" placeholder="请选择" class="ipt-sty" :clearable="true">
              <el-option v-for="item in rateTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option> </el-select>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15 t-right">
          <el-col :span="24">
            <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty()">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="button-area">
        <el-button size="medium" @click="batchSupplierRate">批量设置费率</el-button>
        <el-button size="medium" @click="batchStopCharge">批量停止收费</el-button>
        <el-button size="medium" @click="operatingRateExport">导出</el-button>
        <!-- <el-button size="medium" @click="setGoodRate">设置商品费率</el-button> -->
      </div>
      <div class="back-color-fff p16">
        <el-table :data="supplierRateData" @selection-change="handleSelectionChange" border v-loading="loading">
          <el-table-column type="selection" width="40" header-align="center" align="center"
            :selectable="selectEnable"></el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="supplierName" label="供应商" min-width="250" header-align="center" align="left"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column property="signingFlag" label="签约状态" width="95" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.isSet" v-model="scope.row.signingFlag" placeholder="请选择">
                <el-option v-for="item in signingStatusList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span v-else>{{ scope.row.signingFlag | getSigningType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rateType" label="费率类型" width="120" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.isSet" v-model="scope.row.rateType" placeholder="请选择">
                <el-option v-for="item in rateTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span v-else>{{ scope.row.rateType | getRateType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="费率（％）" width="100" header-align="center" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet && scope.row.rateType == '1'">{{ defaultRate | numDigit }}</span>
              <el-input v-if="scope.row.isSet && scope.row.rateType == '2'" placeholder="请输入" type="text"
                v-model="scope.row.rate"></el-input>
              <span v-if="scope.row.rateType == '3'">-</span>
              <span class="to-commodity-rate" v-if="scope.row.rateType == '4'"
                @click="setGoodRate(scope.row)">按商品计费</span>
              <span v-if="!scope.row.isSet && scope.row.rateType == '1'">{{ scope.row.rate }}</span>
              <span v-if="!scope.row.isSet && scope.row.rateType == '2'">{{ scope.row.rate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="chargeState" label="收费状态" width="108" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.isSet" v-model="scope.row.chargeState" placeholder="请选择">
                <el-option v-for="item in chargeStateList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span v-else>{{ scope.row.chargeState | getChargeState }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="emptyGoodsRateQty" label="费率为空商品数" width="120" header-align="center" align="right"
            show-overflow-tooltip></el-table-column>
          <el-table-column prop="startChargeDate" label="开始收费时间" width="150" header-align="center" align="center">
            <template slot-scope="scope">
              <el-date-picker v-if="scope.row.isSet" v-model="scope.row.startChargeDate" size="small" type="date"
                placeholder="选择日期" style="width: 130px">
              </el-date-picker>
              <span v-else>{{ scope.row.startChargeDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stopChargeDate" label="停止收费时间" width="150" header-align="center" align="center">
            <template slot-scope="scope">
              <el-date-picker v-if="scope.row.isSet" v-model="scope.row.stopChargeDate" size="small" type="date"
                placeholder="选择日期" style="width: 130px">
              </el-date-picker>
              <span v-else>{{ scope.row.stopChargeDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="维护人" width="150" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后维护时间" width="150" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.updateTime | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startFeesDate" label="开始计费时间" width="150" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startFeesDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="recentlyFeesDate" label="最近计费时间" width="150" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recentlyFeesDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" header-align="center" width="170" align="center">
            <template slot-scope="scope">
              <a class="txt-color cursor-sty" @click="supplierEdit(scope.row, scope.$index)">{{ scope.row.isSet ? '保存' :
                '编辑' }} |
              </a>
              <!--  <a class="txt-color cursor-sty" v-if="scope.row.rateType == '4'" @click="supplierEdit(scope.row, scope.$index)"
                                    >编辑 |
                                  </a> -->
              <a class="txt-color cursor-sty" @click="toContract(scope.row)">合同 | </a>
              <a class="txt-color cursor-sty" @click="getGoodsHistoryRateList(scope.row)">查看历史</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination class="pt pb back-color-fff" style="padding: 16px" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
      </el-pagination>
    </div>
    <el-dialog title="费率历史" :visible.sync="dialogTableVisible">
      <el-table :data="supplierRateList">
        <el-table-column property="supplierName" label="供应商" header-align="center" align="center"></el-table-column>
        <el-table-column property="rateType" label="费率类型" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.rateType | getRateType }}</template>
        </el-table-column>
        <el-table-column property="rate" label="费率(％)" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.rate * 100 | numDigit }} </template>
        </el-table-column>
        <el-table-column property="updateTime" label="设置日期" header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime | getDate }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" style="padding: 16px" background @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1" :page-sizes="[5, 25, 50]" :current-page="page1.pageIndex"
        :page-size="page1.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page1.totalRows">
      </el-pagination>
    </el-dialog>
    <el-dialog title="批量设置费率" :visible.sync="supplierRateDialog" width="30%">
      <div class="batch">
        <img width="25" class="fl" src="../../assets/images/remind1.png" />
        <p>费率类型为“自定义费率”时，才能批量设置</p>
      </div>
      <div class="rate">
        <div class="rate-left">账号费率（%）：</div>
        <div class="rate-right">
          <el-input v-model="customRate" placeholder="请输入" :clearable="true"></el-input>
          <p class="t-left">大写：百分之</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="supplierRateDialog = false">取 消</el-button>
        <el-button size="medium" type="info" @click="setBatchRate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量停止收费" :visible.sync="stopChargeDialog" width="30%" :before-close="handleClose">
      <div class="batch">
        <img width="25" class="fl" src="../../assets/images/remind1.png" />
        <p>费率类型为“自定义费率”时，才能批量设置</p>
      </div>
      <div class="rate">
        <div class="rate-left rate-stop">停止收费时间：</div>
        <div class="rate-right">
          <el-date-picker v-model="stopChargeDate" type="date" style="width: 100%" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="stopChargeDialog = false">取 消</el-button>
        <el-button size="medium" type="info" @click="setStopChargeDate">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="合同" :visible.sync="drawer" :direction="direction" :with-header="true" size="40%" :show-close="false"
      :before-close="handleClose">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="first">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" :label-position="right"
            class="demo-ruleForm">
            <el-form-item label="付款单位:" prop="payeeName">
              <el-input v-model="ruleForm.payeeName" autocomplete="off" class="w100f" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="发票类型:" prop="invoiceType">
              <el-select v-model="ruleForm.invoiceType" placeholder="请选择" class="w100f" :clearable="true">
                <el-option label="增值税普通发票" value="1"></el-option>
                <el-option label="增值税专用发票" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否先开票:" class="t-left">
              <el-radio v-model="ruleForm.isInvoiceFirst" label="Y">是</el-radio>
              <el-radio v-model="ruleForm.isInvoiceFirst" label="N">否</el-radio>
            </el-form-item>
            <el-form-item label="纳税人识别号:" prop="invoiceTaxpayerId">
              <el-input v-model="ruleForm.invoiceTaxpayerId" autocomplete="off" class="w100f"
                :clearable="true"></el-input>
            </el-form-item>
            <div v-if="ruleForm.invoiceType == 1">
              <el-form-item label="开户行:">
                <el-input v-model="ruleForm.bank" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="银行账号:">
                <el-input v-model="ruleForm.bankAccount" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="地址:">
                <el-input v-model="ruleForm.address" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="电话:" style="margin-bottom: 20px">
                <el-input v-model="ruleForm.contactTel" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item label="*开户行:" prop="bank">
                <el-input v-model="ruleForm.bank" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="*银行账号:" prop="bankAccount">
                <el-input v-model="ruleForm.bankAccount" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="*地址:" prop="address">
                <el-input v-model="ruleForm.address" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="*电话:" prop="contactTel" style="margin-bottom: 20px">
                <el-input v-model="ruleForm.contactTel" autocomplete="off" class="w100f" :clearable="true"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="邮寄地址:" prop="mailAddress">
              <el-input v-model="ruleForm.mailAddress" autocomplete="off" class="w100f" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="收件人:" prop="recipient">
              <el-input v-model="ruleForm.recipient" autocomplete="off" class="w100f" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="收件人联系电话:" prop="recipientTel">
              <el-input v-model="ruleForm.recipientTel" autocomplete="off" class="w100f" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="邮箱:" prop="email" :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: ['blur', 'change'],
              },
            ]">
              <el-input v-model="ruleForm.email" autocomplete="off" class="w100f" :clearable="true"></el-input>
            </el-form-item>
            <div class="contract-btn">
              <el-button class="btn-close" @click="resetForm('ruleForm')">关闭</el-button>
              <el-button @click="submitForm('ruleForm')">提交</el-button>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="合同明细" name="second" :disabled="!ruleForm.guid">
          <el-button size="medium" type="info" class="fl mb20" @click="editOrSaveDetail(2, '', '')">新增</el-button>
          <el-table :data="mfContractDetails" style="width: 100%" border v-loading="mfContractLoading">
            <el-table-column prop="contractNo" label="合同编号" min-width="200" header-align="center" align="left"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-input v-if="scope.row.isEdit" v-model="scope.row.contractNo" size="small" :clearable="true">
                </el-input>
                <span style="margin-left: 10px" v-else>{{ scope.row.contractNo }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="startDate" label="合同开始时间" width="160" header-align="center" align="center">
              <template slot-scope="scope">
                <el-date-picker v-if="scope.row.isEdit" v-model="scope.row.startDate" size="small" type="date"
                  placeholder="选择日期" style="width: 136px">
                </el-date-picker>
                <span v-else>{{ scope.row.startDate | getDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="endDate" label="合同结束时间" width="160" header-align="center" align="center">
              <template slot-scope="scope">
                <el-date-picker v-if="scope.row.isEdit" v-model="scope.row.endDate" size="small" type="date"
                  placeholder="选择日期" style="width: 136px">
                </el-date-picker>
                <span v-else>{{ scope.row.endDate | getDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" show-overflow-tooltip label="合同扫描件（pdf）" width="110" header-align="center"
              align="center">
              <template slot-scope="scope">
                <el-upload class="upload-demo" v-if="scope.row.isEdit" action="#" :on-preview="handlePreview"
                  :on-remove="handleRemove" :before-remove="beforeRemove" :on-exceed="handleExceed"
                  :on-success="handleSuccess" :headers="token" multiple :limit="1" accept=".pdf" :file-list="fileList"
                  :show-file-list="false" :http-request="(file) => uploadPdf(file, scope.$index)">
                  <div>{{ scope.row.scanCopy ? '点击更换' : '点击上传' }}</div>
                </el-upload>
                <div :class="scope.row.scanCopy ? 'checkPdf' : ''" v-else @click="getPdf(scope.row)">
                  {{ scope.row.scanCopy ? '点击查看' : '暂无附件' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="110" header-align="center" align="center" fixed="right">
              <template slot-scope="scope">
                <a class="txt-color" @click="editOrSaveDetail(1, scope.row, scope.$index)">{{ scope.row.isEdit ? '保存' :
                  '编辑' }} |
                </a>
                <a class="txt-color" @click="deleteContractDetail(scope.row.guid)">删除</a>
              </template>
            </el-table-column>
          </el-table>
          <div class="contract-btn">
            <el-button class="btn-close" @click="resetForm('ruleForm')">关闭</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <el-dialog title="PDF查看" :visible.sync="getPdfFile" fullscreen :append-to-body="true" :close-on-click-modal="false">
      <div class="el-dialog-div">
        <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      getPdfFile: false,
      url: `${route}/ms-common-admin-cloud-service/obs/upload-file`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      //费率类型
      rateTypeList: [
        { value: '1', label: '缺省费率' },
        { value: '2', label: '自定义费率' },
        { value: '3', label: '不计费' },
        { value: '4', label: '按商品计费' },
        { value: '0', label: '未设置' },
      ],
      //收费状态
      chargeStateList: [
        { value: 'Y', label: '正常' },
        { value: 'S', label: '停止收费' },
        { value: 'N', label: '不收费' },
      ],
      //签约状态
      signingStatusList: [
        { value: 'N', label: '未签' },
        { value: 'Y', label: '已签' },
        { value: 'W', label: '无需签' },
      ],
      pdfSrc: '',
      uploadBtn: true,
      stopChargeDate: '',
      supplierRateDialog: false,
      multipleSelection: [],
      showEdit: true,
      stopChargeDialog: false,
      drawer: false,
      direction: 'rtl',
      fileList: [],
      customRate: 0,
      defaultRate: 0,
      numRate: '',
      rateInput: false,
      rateShow: true,
      supplierRateData: [],
      hosData: [
        {
          Id: 1,
          hosName: '常熟市中医院',
          rate: '3.2',
          tableDataList: [
            {
              guid: '1',
              medGuid: 'string',
              delFlag: '',
              medName: 'string',
              supplierGuid: 'string',
              supplierName: '江苏XXXXXXXXXXX供应商',
              rateType: '1',
              rate: 0,
              chargeState: 'Y',
              startChargeDate: '2021-01-06T01:19:18.686Z',
              stopChargeDate: '2021-01-06T01:19:18.686Z',
              startFeesDate: '2021-01-06T01:19:18.686Z',
              recentlyFeesDate: '2021-01-06T01:19:18.686Z',
              createUserId: 'string',
              createUserName: 'string',
              updateUserId: 'string',
              updateUserName: 'string',
              createTime: '2021-01-06T01:19:18.686Z',
              updateTime: '2021-01-06T01:19:18.686Z',
              isDeleted: 'string',
              isInvoiceFirst: 'N',
            },
          ],
        },
      ],
      tableDataList: [],
      right: '',
      activeName: 'first',
      input: '',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: '',
        supplierName: '',
        chargeState: '',
        rateType: '',
        signingFlag: ''
      },
      page1: {
        medGuid: "",
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        totalRows: 0,
        supplierRateGuid: '',
        goodsGuid: '',
      },
      value: '',
      ruleForm: {
        guid: '',
        tenantGuid: '',
        supplierGuid: '',
        payeeGuid: '',
        payeeName: '',
        invoiceType: '2',
        isInvoiceFirst: 'N',
        invoiceTaxpayerId: '',
        bank: '',
        bankAccount: '',
        address: '',
        contactTel: '',
        mailAddress: '',
        recipient: '',
        recipientTel: '',
        email: '',
      },
      dialogTableVisible: false,
      rules: {
        payeeName: [
          { required: true, message: '请输入付款单位名称', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
        invoiceType: [
          { required: true, message: '请选择发票类型', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
        invoiceTaxpayerId: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
        // bank: [
        //   { required: true, message: '请输入开户行', trigger: 'blur' },
        //   {
        //     min: 1,
        //     max: 30,
        //     message: '长度在 1 到 30 个字符',
        //     trigger: 'blur',
        //   },
        // ],
        // bankAccount: [
        //   { required: true, message: '请输入银行账号', trigger: 'blur' },
        //   {
        //     min: 1,
        //     max: 30,
        //     message: '长度在 1 到 30 个字符',
        //     trigger: 'blur',
        //   },
        // ],
        // address: [
        //   { required: true, message: '请输入地址', trigger: 'blur' },
        //   //{ message: '长度在 1 到 30 个字符', trigger: 'blur' },
        // ],
        // contactTel: [
        //   { required: true, message: '请输入电话', trigger: 'blur' },
        //   //{ message: '长度在 1 到 30 个字符', trigger: 'blur' },
        // ],
        mailAddress: [
          { required: true, message: '邮寄地址', trigger: 'blur' },
          // { message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        recipient: [
          { required: true, message: '请输入岗位', trigger: 'blur' },
          { message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        recipientTel: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            min: 1,
            max: 11,
            message: '长度在 1 到 11 个字符',
            trigger: 'blur',
          },
          //   { required: true,
          // pattern: /^1[34578]\d{9}$/,
          // message: '请输入正确手机号！',
          // trigger: 'blur' },
          // { message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        //      phone: [{
        //     required: true,
        //     pattern: /^1[34578]\d{9}$/,
        //     message: '目前只支持中国大陆的手机号码',
        //     trigger: 'blur'
        // }],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          // { message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
      },
      DefaultRateGuid: '',
      contractDetailData: '',
      contractRowData: '',
      mfContractDetails: [],
      pdfFile: '',
      loading: false,
      currentIndex: -1,
      defaultRateList: [],
      goodsRateData: [],
      mfContractLoading: false,
      supplierRateList: [],
    };
  },
  created() {
    // 列表
    this.getSupplierRateList(false);
    this.tableDataList = this.hosData[0].tableDataList;
    //获取缺省费率
    this.getDefaultRate();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/goodsRate') {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      // this.supplierRateData = [];
      // this.page.pageIndex = 1;
      // this.getSupplierRateList();
    } else {
      this.$route.meta.isBack = false;
    }
  },
  methods: {
    handleClose(done) {
    },
    getGoodsHistoryRateList(row) {
      this.dialogTableVisible = true;
      this.page1.medGuid = row.medGuid
      this.page1.supplierGuid = row.supplierGuid
      this.getHistoryRateList(true)

    },
    getHistoryRateList(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page1.pageIndex = 1;
      }
      let medGuid = self.page1.medGuid;
      let pageIndex = self.page1.pageIndex;
      let pageSize = self.page1.pageSize;
      let supplierGuid = self.page1.supplierGuid;
      self.api.get(`/ms-data-business-service/rate/get-supplier-history-rate-list?medGuid=` +
        medGuid +
        `&pageIndex=` +
        pageIndex +
        `&pageSize=` +
        pageSize +
        `&supplierGuid=` +
        supplierGuid
      )
        .then((res) => {
          self.loading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.supplierRateList = res.data.data.records;
            self.page1.totalPage = res.data.data.totalPages;
            self.page1.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取供应商信息
    getSupplierRateList(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      let signingFlag = self.page.signingFlag;
      let rateType = self.page.rateType;
      let medGuid = self.$store.state.medGuid;
      let pageIndex = self.page.pageIndex;
      let pageSize = self.page.pageSize;
      let supplierName = self.page.supplierName;
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/ms-data-business-service/rate/get-supplier-rate-list?signingFlag=` +
            signingFlag +
            `&medGuid=` +
            medGuid +
            `&pageIndex=` +
            pageIndex +
            `&pageSize=` +
            pageSize +
            `&supplierName=` +
            supplierName +
            `&rateType=` +
            rateType,
          )
          .then((res) => {
            self.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.supplierRateData = res.data.data.records;
              if (self.supplierRateData !== null || self.supplierRateData !== []) {
                self.supplierRateData.forEach((item, index) => {
                  if (item.rateType == '1') {
                    self.defaultRateList.push(item);
                  }
                  item['isSet'] = false;
                  item.rate = (item.rate * 100).toFixed(2);
                });
              }
              self.page.totalPage = res.data.data.totalPages;
              self.page.totalRows = res.data.data.totalRows;
              resolve(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    // 搜索
    searchData() {
      let self = this;
      self.getSupplierRateList(true);
    },
    //清空
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: self.$store.state.medGuid,
        supplierName: '',
        chargeState: '',
        rateType: '',
        signingFlag: ''
      };
      self.getSupplierRateList();
    },
    //此时就能拿到整行的信息
    getDetails(row) {
      let self = this;
      self.tableDataList = row.tableDataList;
      self.numRate = row.rate;
      console.log(index);
    },
    //点击修改供应商费率信息
    supplierEdit(row, index) {
      let self = this;
      // if (row.rateType == '4') {
      //   row.isSet = true;
      // }
      // self.getGoodsRateList(row.guid);
      const flag = JSON.parse(JSON.stringify(self.supplierRateData));
      self.currentIndex = index;
      self.supplierRateData = flag;
      let editData = {
        guid: row.guid,
        medGuid: row.medGuid,
        medName: row.medName,
        supplierGuid: row.supplierGuid,
        supplierName: row.supplierName,
        rateType: row.rateType,
        signingFlag: row.signingFlag,
        rate: 0,
        chargeState: row.chargeState,
        startChargeDate: row.startChargeDate && self.$moment(row.startChargeDate).format('YYYY-MM-DD'),
        stopChargeDate: row.stopChargeDate && self.$moment(row.stopChargeDate).format('YYYY-MM-DD'),
      };
      if (row.rateType == '1') {
        editData.rate = self.defaultRate / 100;
      } else if (row.rateType == '2') {
        editData.rate = row.rate / 100;
      } else {
        editData.rate = 0;
      }
      let reg = /^\d+(\.\d{1,2})?$/;
      if (flag[index].rateType == 2) {
        if (reg.test(flag[index].rate)) {
        } else {
          self.$message.warning('请输入数字或两位小数以内的数！');
          return;
        }
      }
      if (flag[index].isSet) {
        let startTime = self.$moment(flag[index].startChargeDate).unix();
        let endTime = self.$moment(flag[index].stopChargeDate).unix();
        console.log(endTime);
        if (endTime < startTime) {
          self.$message.error('结束日期不能比开始日期大！');
        } else if (flag[index].rateType == null || flag[index].rateType == '') {
          self.$message.warning('请选择费率类型！');
          return;
        }
        //else if (row.rateType == '4') {
        // row.isSet = false;
        // return;
        //}
        else {
          self.api.postJson('/ms-data-business-service/rate/update-supplier-rate-info', editData).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('编辑成功!');
              self.getSupplierRateList(false).then((res) => {
                flag[index].isSet = false;
              });
            } else {
              self.$message.error(res.data.msg);
            }
          });
        }
      } else {
        const isEdit = flag.some((item) => item.isSet);
        if (isEdit) {
          self.$message.error('请先保存已编辑的数据!');
        } else {
          flag[index].isSet = true;
        }
      }
    },
    //pdf非空判断
    getPdf(row) {
      let self = this;
      if (!row.scanCopy) {
        return;
      }
      self.getPdfFile = true;
      if (self.mfContractDetails == '' || self.mfContractDetails == null || self.mfContractDetails == undefined) {
        self.pdfSrc = '';
      } else {
        self.pdfSrc = row.scanCopy;
      }
    },
    //是否禁用多选框
    selectEnable(row, rowIndex) {
      if (row.rateType !== '2') {
        return false;
      } else {
        return true; // 不禁用
      }
    },
    //批量设置费率弹窗
    batchSupplierRate() {
      let self = this;
      if (self.multipleSelection.length == 0) {
        self.$message.error('请先勾选数据');
        return;
      } else {
        self.supplierRateDialog = true;
      }
    },
    //批量设置供应商费率确定
    setBatchRate() {
      let self = this;
      let reg = /^\d+(\.\d{1,2})?$/;
      if (reg.test(self.customRate)) {
        self.supplierRateDialog = false;
        let multipleSelectionList = JSON.parse(JSON.stringify(self.multipleSelection));
        multipleSelectionList.forEach((item, index) => {
          item.rate = self.customRate / 100;
          delete item.isSet;
        });
        self.api.postJson('/ms-data-business-service/rate/batch-supplier-rate', multipleSelectionList).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('设置成功!');
            self.getSupplierRateList(false);
          } else {
            self.$message.error(res.data.msg);
          }
        });
        return;
      } else {
        self.$message({
          message: '请输入数字或两位小数以内的数',
          type: 'warning',
        });
        return;
      }
    },

    // 导出
    operatingRateExport() {
      let medGuid = this.$store.state.medGuid;
      let { supplierName, rateType, signingFlag } = this.page;
      this.api
        .post(
          `/ms-data-business-service/rate/mf-supplier-rate-export?` +
          `medGuid=` +
          medGuid +
          `&supplierName=` +
          supplierName +
          `&signingFlag=` +
          signingFlag +
          `&rateType=` +
          rateType,
        ).then(res => {
          if (res.data.code == '00000') {
            this.api
              .postJsonD(`ms-common-admin-cloud-service/excel/export`, res.data.data).then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                let fileName = '运营费率';
                let objectUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download = fileName;
                link.href = objectUrl;
                link.click();
              })
          }
        })
    },
    //批量停止收费弹窗
    batchStopCharge() {
      let self = this;
      if (self.multipleSelection.length == 0) {
        self.$message.error('请先勾选数据');
        return;
      } else {
        self.stopChargeDialog = true;
      }
    },
    //批量停止收费供应商确定
    setStopChargeDate() {
      let self = this;
      if (self.stopChargeDate == '') {
        self.$message.error('请选择时间');
        return;
      } else {
        let multipleSelectionList = JSON.parse(JSON.stringify(self.multipleSelection));
        multipleSelectionList.forEach((item, index) => {
          delete item.isSet;
          self.stopChargeDialog = false;
          item.chargeState = 'S';
          item.stopChargeDate = self.stopChargeDate;
          item.rate = item.rate / 100;
        });
        self.api.postJson('/ms-data-business-service/rate/batch-supplier-rate', multipleSelectionList).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('编辑成功!');
            self.getSupplierRateList(false);
          } else {
            self.$message.error(res.data);
          }
        });
        return;
      }
    },
    //跳转设置商品费率
    setGoodRate(row) {
      let self = this;
      self.$router.push({
        path: '/operatingRate/goodsRate',
        query: { guid: row.guid, pageIndex: self.page.pageIndex, supplier: row.supplierName },
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //点击编辑费率
    editRate() {
      let self = this;
      self.rateInput = true;
      self.rateShow = false;
      self.showEdit = false;
    },
    //查询缺省费率
    getDefaultRate() {
      let self = this;
      self.api.get('/ms-data-business-service/rate/select-rate').then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.defaultRate = res.data.data.rate * 100;
          self.DefaultRateGuid = res.data.data.guid;
          console.log(self.defaultRate);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //将缺省费率传递到主表
    toSupplierDefaultRate() {
      let self = this;
      let newDefaultRate = Number(self.defaultRate / 100);
      self.api.postCan('/ms-data-business-service/rate/update-rate?rate=' + newDefaultRate).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.getSupplierRateList(false);
        } else {
          self.$message.error(res.data);
        }
      });
    },
    //修改缺省费率
    editDefaultRate() {
      let self = this;
      let promise = {
        guid: self.DefaultRateGuid,
        rate: self.numRate / 100,
      };
      let reg = /^\d+(\.\d{1,2})?$/;
      if (reg.test(self.numRate)) {
        self.api.postJson('/ms-data-business-service/rate/insert-rate', promise).then(async (res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('编辑成功!');
            await self.getDefaultRate();
            self.toSupplierDefaultRate();
          } else {
            self.$message.error(res.data.msg);
          }
        });
        self.rateInput = false;
        self.rateShow = true;
        self.showEdit = true;
        self.defaultRate = self.numRate;
      } else {
        self.$message.warning('请输入数字或两位小数以内的数');
      }
    },
    //合同弹窗/获取合同信息
    toContract(row) {
      let self = this;
      self.activeName = 'first';
      self.contractRowData = row;
      self.getContractDetail(row.supplierGuid);
      console.log(row.supplierGuid);
    },
    //合同提交
    submitForm(formName) {
      let self = this;
      if (self.ruleForm.invoiceType == 2) {
        if (self.ruleForm.bank == null || self.ruleForm.bank == '') {
          self.$message.error('请输入开户行！');
          return
        }
        if (self.ruleForm.bankAccount == null || self.ruleForm.bankAccount == '') {
          self.$message.error('请输入银行账号！');
          return
        }
        if (self.ruleForm.address == null || self.ruleForm.address == '') {
          self.$message.error('请输入地址！');
          return
        }
        if (self.ruleForm.contactTel == null || self.ruleForm.contactTel == '') {
          self.$message.error('请输入电话！');
          return
        }
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            supplierGuid: self.contractRowData.supplierGuid,
            tenantGuid: self.ruleForm.tenantGuid,
            payeeGuid: self.ruleForm.payeeGuid,
            payeeName: self.ruleForm.payeeName,
            invoiceType: self.ruleForm.invoiceType,
            isInvoiceFirst: self.ruleForm.isInvoiceFirst,
            invoiceTaxpayerId: self.ruleForm.invoiceTaxpayerId,
            bank: self.ruleForm.bank,
            bankAccount: self.ruleForm.bankAccount,
            address: self.ruleForm.address,
            contactTel: self.ruleForm.contactTel,
            mailAddress: self.ruleForm.mailAddress,
            recipient: self.ruleForm.recipient,
            recipientTel: self.ruleForm.recipientTel,
            email: self.ruleForm.email,
          };
          self.api.postJson('/ms-data-business-service/contract/update-or-insert-contract', promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.getContractDetail(self.contractRowData.supplierGuid);
              self.$message.success('提交成功');
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //查询合同详情
    getContractDetail(supplierGuid) {
      let self = this;
      self.mfContractLoading = true;
      self.contractDetailData = {};
      self.api
        .get('/ms-data-business-service/contract-detail/get-contract-info?' + `supplierGuid=` + supplierGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.contractDetailData = res.data.data;
            // 给合同详情赋值
            self.mfContractDetails = res.data.data.mfContractDetails;
            self.mfContractLoading = false;
            if (res.data.data.mfContractDetails) {
              self.mfContractDetails.forEach((item) => {
                item.scanCopy = JSON.parse(item.scanCopy);
              });
            }
            // 给基本信息赋值
            self.drawer = true;
            console.log(self.contractDetailData);
            if (
              self.contractDetailData.guid === '' ||
              self.contractDetailData.guid === null ||
              self.contractDetailData.guid === undefined
            ) {
              //新增
              self.ruleForm.guid = '';
              self.ruleForm.invoiceType = '1';
              self.ruleForm.isInvoiceFirst = 'N';
            } else {
              //修改
              self.ruleForm.guid = self.contractDetailData.guid;
              self.ruleForm.invoiceType = self.contractDetailData.invoiceType;
              self.ruleForm.isInvoiceFirst = self.contractDetailData.isInvoiceFirst;
            }
            if (self.contractDetailData.payeeName === '' || self.contractDetailData.payeeName === null) {
              self.ruleForm.payeeName = self.contractRowData.supplierName;
            } else {
              self.ruleForm.payeeName = self.contractDetailData.payeeName;
            }
            (self.ruleForm.supplierGuid = self.contractRowData.supplierGuid),
              (self.ruleForm.tenantGuid = self.contractDetailData.tenantGuid);
            self.ruleForm.payeeGuid = self.contractDetailData.payeeGuid;
            self.ruleForm.invoiceTaxpayerId = self.contractDetailData.invoiceTaxpayerId;
            self.ruleForm.bank = self.contractDetailData.bank;
            self.ruleForm.bankAccount = self.contractDetailData.bankAccount;
            self.ruleForm.address = self.contractDetailData.address;
            self.ruleForm.contactTel = self.contractDetailData.contactTel;
            self.ruleForm.mailAddress = self.contractDetailData.mailAddress;
            self.ruleForm.recipient = self.contractDetailData.recipient;
            self.ruleForm.recipientTel = self.contractDetailData.recipientTel;
            self.ruleForm.email = self.contractDetailData.email;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //上传pdf
    uploadPdf(file, index) {
      console.log(index);
      let self = this;
      let formData = new FormData();
      formData.append('file', file.file);
      console.log(self.fileList);
      self.api.postImage(self.url, formData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log(res.data);
          self.mfContractDetails[index].scanCopy = res.data.data.data;
          self.fileList = [];
          console.log(self.pdfFile);
          self.$message({
            message: '上传成功',
            type: 'success',
          });
        } else {
          self.fileList = [];
          self.$message.error('上传失败!');
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    handleSuccess(...args) {
      console.log(args, 1);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    //合同列表编辑或保存
    editOrSaveDetail(flg, row, index) {
      let self = this;
      //新增
      if (flg == 2) {
        const isEdit = self.mfContractDetails.some((item) => item.isEdit);
        if (isEdit) {
          self.$message.error('请先保存已编辑的数据!');
        } else {
          let newRow = {
            contractNo: '',
            startDate: '',
            endDate: '',
            scanCopy: '',
            isEdit: true,
          };
          self.mfContractDetails.unshift(newRow);
        }
      } else {
        const flag = JSON.parse(JSON.stringify(self.mfContractDetails));
        self.mfContractDetails = flag;
        //保存
        if (flag[index].isEdit) {
          let startTime = self.$moment(flag[index].startDate).unix();
          let endTime = self.$moment(flag[index].endDate).unix();
          console.log(endTime);
          if (endTime < startTime) {
            self.$message.error('结束日期不能比开始日期大！');
          } else {
            flag[index].isEdit = false;
            let promise = {
              guid: row.guid,
              contractGuid: self.contractDetailData.guid,
              contractNo: row.contractNo,
              startDate: row.startDate && self.$moment(row.startDate).format('YYYY-MM-DD'),
              endDate: row.endDate && self.$moment(row.endDate).format('YYYY-MM-DD'),
              scanCopy: JSON.stringify(row.scanCopy),
            };
            if (row.guid) {
              promise.guid = row.guid;
            } else {
              promise.guid = '';
            }
            console.log(promise);
            self.api
              .put('/ms-data-business-service/contract-detail/insert-or-update-contract-detail', promise)
              .then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.$message.success('保存成功!');
                  self.getContractDetail(self.contractRowData.supplierGuid);
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          }
          //编辑
        } else {
          const isEdit = flag.some((item) => item.isEdit);
          if (isEdit) {
            self.$message.error('请先保存已编辑的数据!');
          } else {
            flag[index].isEdit = true;
          }
        }
      }
    },

    // },
    //删除合同详情
    deleteContractDetail(guid) {
      let self = this;
      self.api.postJson('/ms-data-business-service/contract-detail/delete-contract-detail?guid=' + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('删除成功！');
          self.getContractDetail(self.contractRowData.supplierGuid);
          // self.contractRowData.supplierGuid
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //重置表单
    resetForm(formName) {
      let self = this;
      self.$refs[formName].resetFields();
      self.drawer = false;
    },

    //选中的数据
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item);
      });
      console.log(self.multipleSelection);
      console.log(val);
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getSupplierRateList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getSupplierRateList();
    },
    // 费率历史
    handleSizeChange1(val) {
      let self = this;
      self.page1.pageSize = val;
      self.page1.pageIndex = 1;
      this.getHistoryRateList(false);
    },
    // 费率历史
    handleCurrentChange1(val) {
      let self = this;
      self.page1.pageIndex = val;
      this.getHistoryRateList(false);
    },
  },
};
</script>